import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useQuery } from "@tanstack/react-query";
import { getCaseOfficerHistory } from "./caseOfficerApi";

/**
 * Read-only log of who a client's case officer moved between: complete tracking for officer
 * changes, mirroring the referrer history. The change itself happens on the client save,
 * gated on the assign-officer permission there.
 */
const CaseOfficerHistoryDialog = ({ open, clientId, onClose }) => {
  const { data = [], isLoading } = useQuery(
    ["case-officer-history", clientId],
    () => getCaseOfficerHistory(clientId),
    { enabled: open && !!clientId }
  );

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Case officer history</DialogTitle>
      <DialogContent dividers>
        {isLoading ? (
          <CircularProgress size={20} />
        ) : !data.length ? (
          <p className="text-sm m-0">No case officer changes recorded.</p>
        ) : (
          <ul className="text-sm pl-4 m-0 space-y-2">
            {data.map((row) => (
              <li key={row.id}>
                <strong>{row.fromOfficerName || "No officer"}</strong> →{" "}
                <strong>{row.toOfficerName || "No officer"}</strong> — {row.reason}
                <span className="text-app-text-muted">
                  {" "}
                  · {row.actorName || "System"} · {new Date(row.createdAt).toLocaleString()}
                </span>
              </li>
            ))}
          </ul>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default CaseOfficerHistoryDialog;
